export const InfoIcon = ({ width = 16, height = 16, color = '#CED4DA', ...props }: JSX.IntrinsicElements['svg']) => (
  <svg width={width} height={height} color={color} viewBox='0 0 16 16' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM7.25 5.75V4.25H8.75V5.75H7.25ZM7.25 11.75V6.75H8.75V11.75H7.25Z'
      fill='currentColor'
    />
  </svg>
);
